import { render } from "./ProviderUser.vue?vue&type=template&id=3c8d19f9&scoped=true&ts=true"
import script from "./ProviderUser.vue?vue&type=script&lang=ts"
export * from "./ProviderUser.vue?vue&type=script&lang=ts"

import "./ProviderUser.vue?vue&type=style&index=0&id=3c8d19f9&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2796879663/src/bitbucket.org/island-c/cayman-fe-operator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c8d19f9"]])

export default __exports__